var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 12.6667H24.375V9.04762C24.375 4.05333 20.175 0 15 0C9.825 0 5.625 4.05333 5.625 9.04762V12.6667H3.75C1.6875 12.6667 0 14.2952 0 16.2857V34.381C0 36.3714 1.6875 38 3.75 38H26.25C28.3125 38 30 36.3714 30 34.381V16.2857C30 14.2952 28.3125 12.6667 26.25 12.6667ZM15 28.9524C12.9375 28.9524 11.25 27.3238 11.25 25.3333C11.25 23.3429 12.9375 21.7143 15 21.7143C17.0625 21.7143 18.75 23.3429 18.75 25.3333C18.75 27.3238 17.0625 28.9524 15 28.9524ZM20.8125 12.6667H9.1875V9.04762C9.1875 5.95333 11.7937 3.4381 15 3.4381C18.2063 3.4381 20.8125 5.95333 20.8125 9.04762V12.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/protect.79819d0f409cececab2894651c114fdb.svg";
export { ForwardRef as ReactComponent };